module.exports = require("rc-tree-select/assets/index.css");